export class GeolocationCondition {
  constructor(public source = '', public type = '') {}
}

export class GeolocationModel {
  constructor(public name = '', public conditions: GeolocationCondition[] = []) {}
}
